import React, { FC } from 'react';
import { PagiArrowCont, PaginationArrowButton } from './ArrowButton.styles';
import ArrowIcon from '@/assets/icons/arrowRightIcon.svg?react';

interface IArrowButton {
  onClick: () => void;
  disabled?: boolean;
  left?: boolean;
}

const ArrowButton: FC<IArrowButton> = ({ onClick, disabled, left }) => (
  <PaginationArrowButton data-testid="PaginationArrowButton" disabled={disabled} onClick={onClick}>
    <PagiArrowCont left={left}>
      <ArrowIcon />
    </PagiArrowCont>
  </PaginationArrowButton>
);

export default ArrowButton;
